import { Component, OnInit, Input, Output, EventEmitter, NgModule, AfterViewInit,ViewChild,ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SkeletonModule } from 'primeng/skeleton';

import { PDetailSidebarModule } from './../../../components/p-detail-sidebar/p-detail-sidebar.component';
import { DriverDetailModule } from './../../../components/driver-detail/driver-detail.component';
import { TruckDetailModule } from './../../../components/truck-detail/truck-detail.component';
import { ProgressBarModule } from 'primeng/progressbar';                                                            // 进度条
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { DomSanitizer } from '@angular/platform-browser';
import { RegExUtils } from '../../../utils/RegExUtils';
import { OssFileService } from './../../../components/oss-file/oss-file.service';
import { HttpHelpUtils } from './../../../utils/HttpHelpUtils';
import { TimelineModule } from 'primeng/timeline';
import { RadioButtonModule } from 'primeng/radiobutton';
import { BaseCommpont } from 'src/app/utils/BaseCommpont';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { ConfirmationService } from 'primeng/api';
import { MessageSub } from './../../../utils/MessageSub';
import { DialogModule} from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FieldsetModule } from 'primeng/fieldset';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TooltipModule } from 'primeng/tooltip';
import { AccordionModule } from 'primeng/accordion';

import { CommonConfirmModule } from './../../../components/common-confirm/common-confirm.component';
import { ImagePreviewService } from './../../image-viewer/image-preview.service';
import { ImageViewerModule } from './../../../components/image-viewer/image-viewer.directive';
import { CalendarModule } from '../../../components/calendar/calendar.component';
import { TagModule } from 'primeng/tag';

declare const TweenMax: any;
declare const Linear: any;
declare const TimelineMax: any;
declare const Cubic: any;

@Component({
  selector: 'app-driver-examine',
  templateUrl: './driver-examine.component.html',
  styleUrls: ['./driver-examine.component.scss'],
  providers: [ConfirmationService]
})
export class DriverExamineComponent implements OnInit, AfterViewInit {
    checkDriverForm: FormGroup;
    @Input() driverDetail: {} = {};                                             // 运单输入详情
    @Output() onClose: EventEmitter<any> = new EventEmitter();                  // 关闭弹窗
    @Output() onChecked: EventEmitter<any> = new EventEmitter();                  // 审核完毕
    @Input() percentWidth = 80;                                                 // 宽度比例，默认是80%；
    @ViewChild("viewComponent") viewComponent: ElementRef;

    regExUtils = new RegExUtils();                                  // 校验规则
    bc = new BaseCommpont();
    localDriverDetail = {};                                                        // 司机详情
    checkDriverDialog = false;                                                     // 审核不通过窗口
    forceCheckDriverDialog = false;                                                // 强制审核通过
    scanItems = [];                                                                 // 扫描项
    driverId = '';
    viewWidth = 0;

    constructor(
        private httpHelp: HttpHelpUtils,
        private messageSub: MessageSub,
        private configSrv: ConfirmationService,
        private fb: FormBuilder,
        private ossFileService: OssFileService,
        private imagePreviewService: ImagePreviewService,
        private sanitizer : DomSanitizer
    ) { }

    riskColor = {
        1: 'red',
        5: '#c1c116',
        10: 'green'
    }

    riskType = {
        1: '高风险',
        5: '中风险',
        10: '低风险'
    }

    useStatus = {                                                     // 使用状态
        0: '空闲',
        1: '工作中'
    };

    sex = {
        1:'男',
        0:'女'
    };

    source = {
        0:'系统录入',
        1:'EXECL导入',
        2:'微信小程序',
        3:'司机端APP'
    }

    signStatus = {
        0:'待签署',
        1:'签署中',
        2:'已签署',
        3:'签署失败'
    }

    checkFlag = {                                                     // 审核状态
        0: "待提交",
        1: "待审核",
        2: "已审核",
        3: "审核不过",
        4: "未实名"
    };

    // =========================审核以及扫描方法
    scanData = null;
    robotClick = null;
    rightHandShake = null;
    scanStop = false;
    leftHandShake = null;
    reScanHeight = 0;
    scanRunning = false;
    eyeShake: any;
    robotBackTrans: any;
    loadingDriverInfo = false;
    
    closeDetail() {
        this.onClose.emit();
    }

    //审核状态颜色
    getCheckFlag = (val) => {
        if (val == 0) {
            return '#EE9A00';
        } else if (val == 1) {
            return '#B15BFF';
        } else if (val == 2) {
            return '#00A600';
        }else if (val == 3) {
            return '#EA0000';
        }
    }

    // 扫描动作
    scanAnimation() {
        const that = this;
        TweenMax.to(".scanItems", 1, {
            height: 0,
            autoAlpha: 0,
            visibility: "hidden",
            ease: Cubic.easeInOut,
            overwrite: "none"
        });
        that.scanRunning = true;
        if (that.robotBackTrans) {
            that.robotBackTrans.play();
        } else {
            that.robotBackTrans = new TweenMax.to(".robot-back", 1, {repeat: -1, rotation: 360, ease: Linear.easeNone});
        }
        TweenMax.to(".robot-back", 1, {height: '170px', width: '170px', ease: Linear.easeNone});
        TweenMax.to(".scan-stop", 0.1, {visibility: "hidden"});
        TweenMax.to(".scan-run", 0.1, {visibility: "inherit"});
    }
    
    // 停止扫描动作
    scanStopAnimation() {
        const that = this;
        that.scanRunning = false;
        if (that.eyeShake) {
            that.eyeShake.play();
        } else {
            that.eyeShake = new TweenMax.to(".leftEye,.rightEye", 1, {repeat: -1, transform: 'rotateX(-75deg)', ease: Linear.easeNone, yoyo:true}); 
        }
        TweenMax.to(".scan-stop", 0.1, {visibility: "inherit"});
        TweenMax.to(".scan-run", 0.1, {visibility: "hidden"});
        // 显示下拉
        if (that.reScanHeight == 0) {
            that.reScanHeight  = document.getElementById('scanItems').offsetHeight + 20 < 74 ? 74 : document.getElementById('scanItems').offsetHeight + 20;
        }
        TweenMax.to(".robot-back", 1, {height: '110px', width: '110px', ease: Linear.easeNone});
        that.robotBackTrans.pause();

        TweenMax.set(".scanItems", {
            height: 0,
            autoAlpha: 0,
            visibility: "hidden"
        });

        TweenMax.set(".scanChild", {
            autoAlpha: 0,
            visibility: "hidden"
        });

        const tlm = new TimelineMax();


        // animate stuff
        tlm.to(".scanItems", 1, {
            height: that.reScanHeight,
            autoAlpha: 1,
            visibility: "inherit",
            ease: Cubic.easeInOut,
            overwrite: "none"
        }).to(".scanChild", 0.5, {
            autoAlpha: 1,
            visibility: "inherit"
        });
    }
    
    // 监听点击事件
    initRodotClick() {
        const that  = this;
        document.getElementById("robot").addEventListener("click", () => {
            if (that.scanRunning) {
                return;
            }
        });

        // 监听双击事件
        document.getElementById("robot").addEventListener("dblclick", () => {
            if (that.scanRunning) {
                return;
            }
            that.scanRunning = true;
            that.queryTotalRiskItem();
        });
    }
    
    // 重新设置robot
    resetRobot() {
        // this.scanData.
        TweenMax.to( "#faces", 0.5, { x: 0 });

        TweenMax.set("#left-hand", {
            x: 20,
            y: -20,
            transformOrigin: "right center"
        });
        TweenMax.to( "#left-hand", 0.5, { x: 0 });
        if (this.leftHandShake) {
            this.leftHandShake.play();
        } else {
            this.leftHandShake = TweenMax.to( "#left-hand", 0.5, { rotation: 20, yoyo: true, ease: "sine.inOut" });
        }
        TweenMax.to( "#right-hand", 0.4, { rotation: 0 } );
        const that = this;
        if (that.reScanHeight == 0) {
            that.reScanHeight  = document.getElementById('scanItems').offsetHeight + 20;
        }
        
        TweenMax.set(".scanItems", {
            height: 0,
            autoAlpha: 0,
            visibility: "hidden"
        });
        // animate stuff
        TweenMax.to(".scanItems", 1, {
            delay: 0.5,
            height: that.reScanHeight,
            autoAlpha: 1,
            visibility: "inherit",
            ease: Cubic.easeInOut,
            overwrite: "none"
        });
    }

    queryTotalRiskItem() {
        this.scanAnimation();
        this.httpHelp.get('psg/risk/get-total-risk-data', {riskType: 1}).then(res => {
            if (res['status'] == 'success') {
                const riskList: [] = res['data']['riskList'];
                this.analysisTotalRiskData(riskList);
            }
        });
    }
    
    // 风控项涉及接口以及数据，分接口异步处理
    analysisTotalRiskData(data:[]) {
        const that = this;
        let func:any = [];
        data.forEach(e => {
            func.push(that.analysisSingleData(e));
        });

        let tempScanItem = [];
        Promise.all(func).then(res => {
            res.forEach(e => {
                if (e['status'] == 'success') {
                    const items:{} = e['data'];
                    for (let key in items) {
                        if (items[key].indexOf('1-') != -1) {
                            tempScanItem.push({
                                key: key,
                                label: items[key].split('-')[2],
                                status: 1,
                                riskType: items[key].split('-')[1]
                            });
                        } else {
                            tempScanItem.push({
                                key: key,
                                label: key + '校验通过',
                                status: 0
                            });
                        }
                    }
                }
            });
            tempScanItem.sort((a, b) => b['status'] - a['status'] || a['riskType'] - b['riskType'] );
            that.scanStopAnimation();
            that.scanItems = tempScanItem;
        });
    }
    
    analysisSingleData(item) {
        return this.httpHelp.get('psg/risk/analysis-single-risk-data', 
        {dataId: this.driverId, riskDataId: item['riskDataId']});
    }

    checkDriver(status) {
        const that = this;
        if (status == 15) {
            that.saveCheckDriver(status);
        } else if (status == 10) {
            let heightRisk = false;
            let middleRisk = false;
            that.scanItems.forEach(e => {
                if (e['riskType'] == 1) {
                    heightRisk = true;
                }
                if (e['riskType'] == 5) {
                    middleRisk = true;
                }
            });
            if (heightRisk) {
                // 有高风险，不能审核通过，提示有高风险，请先处理高风险
                that.bc.showMessage(that.messageSub,  '扫描中有高风险项，请先处理高风险项，再进行审核通过', 'error');
                return;
            }
            if (middleRisk) {
                that.forceCheckDriverDialog = true;
                return;
            }
            that.saveCheckDriver(10);
        }
    }
    
    // 审核运单操作
    saveCheckDriver(status, msg?) {
        const that = this;
        if (status == 15) {
            if (that.checkDriverForm.controls['checkLog'].invalid) {
                that.checkDriverForm.controls['checkLog'].markAsDirty();
                that.checkDriverForm.controls['checkLog'].updateValueAndValidity();
                return;
            }
            const options = {
                id: that.driverId,
                checkLog: that.checkDriverForm.get('checkLog').value
            };
            that.httpHelp.loadingBlock = true;
            that.httpHelp.post('psg/drivers/noChecks-drivers',
                options
            ).then(res => {
                that.httpHelp.loadingBlock = false;
                if (res['status'] == 'success') {
                    if (status == 15) {
                        that.checkDriverDialog = false;
                    }
                    that.forceCheckDriverDialog = false;
                    this.onClose.emit();
                    this.onChecked.emit()
                } else {
                    that.bc.showMessage(that.messageSub, res['message'], 'error');
                }
            });
            return;
        }

        this.configSrv.confirm({
            message: msg || '确定'+ (status == 10 ? '审核通过' : '审核不通过') +'吗？',
            icon: 'pi pi-exclamation-triangle',
            header: '审核确认',
            acceptLabel: '确定',
            rejectLabel: '取消',
            rejectButtonStyleClass: 'p-button-raised p-button-text p-button-plain',
            accept: () => {
                this.httpHelp.loadingBlock = false;
                this.httpHelp.get('psg/drivers/check-driversOne', 
                        {
                            ids: this.driverId,
                            // checkDriverStatus: status,
                            // checkLog: that.checkDriverForm.get('checkLog').value,
                            // riskItems: JSON.stringify(that.scanItems) 
                        }).then(res => {
                    if (res['status'] == 'success') {
                        if (status == 15) {
                            that.checkDriverDialog = false;
                        }
                        that.forceCheckDriverDialog = false;
                        this.onClose.emit();
                         this.onChecked.emit()
                        that.bc.showMessage(that.messageSub, (status == 10 ? '审核通过' : '审核不通过') + '成功');
                    }
                });
            },
            reject: () => {

            },
            key: 'confirm'
        });
    }

    // ========================审核以及扫描方法结束============================== //
    showDriverCheckFlag = false;
    idCardNoFront;
    idCardNoBack;
    drivingLicense;
    drivingLicenseBack;
    imgPriview: '';                                                               // 展示图
    thumbnailImageSrc = [];                                                       // 缩略图
    current = 0;                                                                  // 旋转角度
    imgDescribe = '';
    relTruckList = [];
    bankAccountList = [];
    relAgentorList = [];
    relAgentList = [];
    relCusList = [];
    checkList = [];
    checkDriverFlag() {
        this.localDriverDetail = {};
        this.idCardNoFront = '';
        this.idCardNoBack = '';
        this.drivingLicense = '';
        this.thumbnailImageSrc = [];
        this.imgDescribe = '';
        this.relTruckList = [];
        this.bankAccountList = [];
        this.relAgentorList = [];
        this.relAgentList = [];
        this.relCusList = [];
        // this.tempId = null;
        this.checkList = [];
        //加载司机基础数据
        this.httpHelp.loadingBlock = true;
        this.httpHelp.get('psg/drivers/get-driver-detail', { driverId: this.driverId }).then(res => {
            this.httpHelp.loadingBlock = false;
            if (res['status'] == 'success') {
                if (res['data']) {
                    this.localDriverDetail = res['data'];
                    this.localDriverDetail['expiredWarnDay'] = this.localDriverDetail['expiredWarnDay'];
                    // this.tempId = this.localDriverDetail['id'];
                    // 身份证正面
                    if (this.localDriverDetail['idCardNoFront']) {
                        this.ossFileService.viewOSSFile('idcard', this.localDriverDetail['idCardNoFront'],2).then(res1 => {
                            this.idCardNoFront = res1['data']['url'];
                            let obj = { 'url': this.idCardNoFront, 'title': '身份证正面' };
                            this.thumbnailImageSrc.push(obj);
                            if (this.thumbnailImageSrc.length > 0) {
                                this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                            }
                        })
                    }
                    // 身份证正面
                    if (this.localDriverDetail['idCardNoBack']) {
                        this.ossFileService.viewOSSFile('idcard', this.localDriverDetail['idCardNoBack'],2).then(res2 => {
                            this.idCardNoBack = res2['data']['url'];
                            let obj = { 'url': this.idCardNoBack, 'title': '身份证反面' };
                            this.thumbnailImageSrc.push(obj);
                            if (this.thumbnailImageSrc.length > 0) {
                                this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                            }
                        })
                    }
                    //驾驶证主页
                    if (this.localDriverDetail['drivingLicensePhoto']) {
                        this.ossFileService.viewOSSFile('idcard', this.localDriverDetail['drivingLicensePhoto'],2).then(res3 => {
                            this.drivingLicense = res3['data']['url'];
                            let obj = { 'url': this.drivingLicense, 'title': '驾驶证主页' };
                            this.thumbnailImageSrc.push(obj);
                            if (this.thumbnailImageSrc.length > 0) {
                                this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                            }
                        })
                    }
                    //驾驶证副页
                    if (this.localDriverDetail['drivingLicenseBackPhoto']) {
                        this.ossFileService.viewOSSFile('idcard', this.localDriverDetail['drivingLicenseBackPhoto'],2).then(res4 => {
                            this.drivingLicenseBack = res4['data']['url'];
                            let obj = { 'url': this.drivingLicenseBack, 'title': '驾驶证副页' };
                            this.thumbnailImageSrc.push(obj);
                            if (this.thumbnailImageSrc.length > 0) {
                                this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                            }
                        })
                    } else {
                        // 如果后端没有返回驾驶证副页，使用占位图
                        this.drivingLicenseBack = 'assets/file/image/jsz_fyb.png';
                        let obj = { 'url': this.drivingLicenseBack, 'title': '驾驶证副页' };
                        this.thumbnailImageSrc.push(obj);
                        if (this.thumbnailImageSrc.length > 0) {
                            this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                        }
                    }
                    //从业资格证
                    if (this.localDriverDetail['qualificationCertPhoto']) {
                        this.ossFileService.viewOSSFile('idcard', this.localDriverDetail['qualificationCertPhoto'],2).then(res5 => {
                            this.drivingLicense = res5['data']['url'];
                            let obj = { 'url': this.drivingLicense, 'title': '从业资格证' };
                            this.thumbnailImageSrc.push(obj);
                            if (this.thumbnailImageSrc.length > 0) {
                                this.imgDescribe = this.thumbnailImageSrc[0]['title'];
                            }
                        })
                    }
                }
                //加载审核日志
                this.httpHelp.get('psg/operateLog/get-check-log-list', { objId: this.driverId, objType: 1 }).then(res2 => {
                    if (res2['status'] == 'success') {
                        this.checkList = [{
                            remark: '',
                            status: 1,
                            createTime: this.localDriverDetail['createTime'],
                            creatorName: this.localDriverDetail['creatorName']
                        }];
                        let data = res2['data'];
                        if (data) {
                            data.forEach(item => {
                                this.checkList.push({
                                    status: item.status,
                                    createTime: item.createTime,
                                    creatorName: item.creatorName,
                                    remark: item.remark
                                });
                            });
                        }
                    } else {
                        this.bc.showMessage(this.messageSub, '加载审核日志异常：' + res2['message'], 'error');
                    }
                });
                this.showDriverCheckFlag = true;
                
                // 获取从业资格证颁发机构所在地（在数据加载成功后执行）
                if (this.localDriverDetail['qualificationCertIssueAreaCode']) {
                    this.getAreaNameByCode(this.localDriverDetail['qualificationCertIssueAreaCode']).then(areaName => {
                        this.qualificationCertIssueArea = areaName;
                    });
                }
            } else {
                this.bc.showMessage(this.messageSub, '加载基础数据异常：' + res['message'], 'error');
            }
        });
        this.httpHelp.get('psg/drivers/get-driver-rel-detail', { driverId: this.driverId }).then(res => {
            if (res['status'] == 'success') {
                if (res['data']) {
                    this.relTruckList = res['data']['relTruckList'];//关联车辆
                    this.bankAccountList = res['data']['bankAccountList'];//关联银行卡
                    this.relAgentorList = res['data']['relAgentorList'];//关联车队长
                }
            } else {
                this.bc.showMessage(this.messageSub, '加载关联数据异常：' + res['message'], 'error');
            }
        });
    }
    // 预览右侧缩略图
    previewThumbnailImage() {
        var img = document.querySelector('.img-preview-img').getAttribute("src")
        let show_photo_list = [];
        let index = 0;
        for (var i = 0; i < this.thumbnailImageSrc.length; i++) {
            let e = this.thumbnailImageSrc[i];
            if (e['url'] == img) {
                index = i;
            }
            show_photo_list.push(e['url']);
        }
        this.imagePreviewService.preview(show_photo_list, index);
    }
    // 向左旋转
    handleTurnLeft() {
        let img = <HTMLImageElement>document.querySelector('.img-preview')
        this.current = (this.current - 90) % 360;
        img.style.transform = 'rotate(' + this.current + 'deg)'
    }
    // 向右旋转
    handleTurnright() {
        let img = <HTMLImageElement>document.querySelector('.img-preview')
        this.current = (this.current + 90) % 360;
        img.style.transform = 'rotate(' + this.current + 'deg)'
    }
    // 预览图切换
    previewImgIndex = 0                                                                           // 小图下标
    afiles = [];
    handlePreviewImgClick(item, i) {
        this.imgPriview = item.url;
        this.imgDescribe = item.title;
        this.previewImgIndex = i;
        this.current = 0
        this.afiles.push(this.imgPriview)
    }
    // ========================================司机初始化审核结束================================ //

    showTruckDetailDialog = false;
    truckDetail = {};
    showTruckDetail(item) {
        console.log('点击车牌号，打开车辆详情，车牌号:', item.plateNumber, 'truckId:', item.truckId);
        this.truckDetail = {
            truckId: item.truckId
        }
        this.showTruckDetailDialog = true;
    }

    // 查看司机人车照
    checkDriverTruckPhoto(data) {
        console.log('点击已上传，查看人车照片，车牌号:', data['plateNumber']);
        if (!data || !data['driverTruckPhoto']) {
            this.bc.showMessage(this.messageSub, '未找到人车照片信息', 'error');
            return;
        }
        
        this.ossFileService.viewOSSFile(this.regExUtils.TRUCK, data['driverTruckPhoto'], 2).then(res => {
            if (res['status'] == 'success') {
                this.imagePreviewService.preview([
                    res['data']['url']
                ]);
            } else {
                this.bc.showMessage(this.messageSub, res['message'], 'error');
            }
        }).catch(err => {
            console.log('查看人车照片发生异常:', err);
        });
    }

    vehicleTypeMap = {};
    vehicleTypeList = [];
    plateColorLists = []; //车牌颜色
    energyTypeLists = [];//车辆能源类型
    isPersonalLists = [];//车辆属性
    useCharacterLists = [];//使用性质
    truckModelLists = [];//车型
    truckSizeLists = [];//车辆尺寸
    plateColorMap = {}; //车牌颜色
    energyTypeMap = {};//车辆能源类型
    isPersonalMap = {};//车辆属性
    useCharacterMap = {};//使用性质
    truckModelMap = {};//车型
    truckSizeMap = {};//车长
    driverTypeMap = {};
    driverTypeList = [];
    politicalOutlookMap = {};//政治面貌
    politicalOutlookLists = [];
    modelList = [];
    useCharacterList = [];
    truckSizeList = [];
    qualificationCertIssueArea = '';  // 从业资格证颁发机构所在地（省+市）
    
    getDriverDic() {
        //初始化代码表字典
        this.httpHelp.get('psg/diction/dicType',
            { dicTypes: 'vehicle_classification_code,use_type,brand,truck_length,driving_license,political_outlook,plate_color,energy_type,is_personal,use_character,truck_length,truck_type' }).then(res => {
            if (res['status'] == 'success') {
                const tempGoodsTypeList = res['data'];
                tempGoodsTypeList.forEach(e => {
                    if (e['dicType'] == 'vehicle_classification_code') {
                        this.vehicleTypeMap[e['value']] = e['text'];
                        this.vehicleTypeList.push({
                            label: e['text'],
                            value: e['value']
                        })
                    } else if (e['dicType'] == 'brand') {
                        this.modelList.push({
                            label: e['text'],
                            value: e['value']
                        });
                    } else if (e['dicType'] == 'use_type') {
                        this.useCharacterList.push({
                            label: e['text'],
                            value: e['value']
                        })
                    } else if (e['dicType'] == 'truck_length') {
                        this.truckSizeList.push({
                            label: e['text'],
                            value: e['value']
                        })
                    } else if (e['dicType'] == 'driving_license') {
                        this.driverTypeMap[e['value']] = e['text'];
                        this.driverTypeList.push({
                            label: e['text'],
                            value: e['value']
                        })
                    }else if(e['dicType'] == 'political_outlook'){
                        //政治面貌
                        this.politicalOutlookMap[e['value']] = e['text'];
                        this.politicalOutlookLists.push({
                            label: e['text'],
                            value: e['value']
                        })
                    }
                    //车牌颜色
                    if (e['dicType'] == 'plate_color') {
                        this.plateColorMap[e['value']] = e['text'];
                        this.plateColorLists.push({
                        label: e['text'],
                        value: e['value']
                        })
                    }
                    //车辆能源类型
                    if (e['dicType'] == 'energy_type') {
                        this.energyTypeMap[e['value']] = e['text'];
                        this.energyTypeLists.push({
                        label: e['text'],
                        value: e['value']
                        })
                    }
                    //车辆属性
                    if (e['dicType'] == 'is_personal') {
                        this.isPersonalMap[e['value']] = e['text'];
                        this.isPersonalLists.push({
                        label: e['text'],
                        value: e['value']
                        })
                    }
                    //使用性质
                    if (e['dicType'] == 'use_character') {
                        this.useCharacterMap[e['value']] = e['text'];
                        this.useCharacterLists.push({
                        label: e['text'],
                        value: e['value']
                        })
                    }
                    //车长
                    if (e['dicType'] == 'truck_length') {
                        this.truckSizeMap[e['value']+''] = e['text'];
                        this.truckSizeLists.push({
                        label: e['text'],
                        value: e['value']+''
                        })
                    }
                    //车型
                    if (e['dicType'] == 'truck_type') {
                        this.truckModelMap[e['value']] = e['text'];
                        this.truckModelLists.push({
                        label: e['text'],
                        value: e['value']
                        })
                    }
                });
            } else {
                // this.showMessage()
            }
        });
    }

    // 根据地区编码获取省市名称
    async getAreaNameByCode(areaCode: string): Promise<string> {
        if (!areaCode) {
            return '';
        }
        
        try {
            // 获取省份列表
            const provinceRes = await this.httpHelp.get('psgsys/sj/areainfo/getAreaList?pAreaCode=0&provinceName=', {});
            
            if (provinceRes['code'] !== 0 || !provinceRes['data']) {
                return '';
            }
            
            // 从市级编码获取省级编码（前2位+"0000"）
            const provinceCode = areaCode.substring(0, 2) + '0000';
            
            // 查找省份名称（使用宽松比较以处理字符串和数字类型）
            const province = provinceRes['data'].find(p => p['areaCode'] == provinceCode);
            
            if (!province) {
                return '';
            }
            
            const provinceName = province['areaName'];
            
            // 获取城市列表
            const cityRes = await this.httpHelp.get('psgsys/sj/areainfo/getAreaList?pAreaCode=' + provinceCode + '&provinceName=', {});
            
            if (cityRes['code'] !== 0 || !cityRes['data']) {
                return provinceName;
            }
            
            // 查找城市名称（使用宽松比较以处理字符串和数字类型）
            const city = cityRes['data'].find(c => c['areaCode'] == areaCode);
            const cityName = city ? city['areaName'] : '';
            
            // 返回省+市
            return cityName ? provinceName + cityName : provinceName;
        } catch (error) {
            console.error('获取地区名称失败:', error);
            return '';
        }
    }

    //查看法大大协议
    showFadadaDriverFlag = false;//弹框开关
    agreeHeaderTitle = '';//标题
    safeUrl;//协议链接地址
    showFadadaDriverAgree(res){
        if (res['contractNo']) {
            this.agreeHeaderTitle = '委托代开协议（' + res['realname'] + '）';
            this.httpHelp.loadingBlock = true;
            this.httpHelp.get('psg/drivers/get-driver-fadada', { contractNo: res['contractNo'] }).then(res => {
                this.httpHelp.loadingBlock = false;
                if (res['status'] == 'success' && res['data']) {
                    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res['data']['signUrl']);
                    this.showFadadaDriverFlag = true;
                } else {
                    this.bc.showMessage(this.messageSub, '获取法大大协议失败：' + res['message'], 'error');
                }
            });
        }
    }

    ngOnInit(): void {
        this.checkDriverForm = this.fb.group({
            checkLog: [null, [Validators.required]],
        });
    }

    ngAfterViewInit(): void {
        this.viewWidth = this.viewComponent.nativeElement.offsetWidth;
        
        // AI机器人测评功能已隐藏
        // this.initRodotClick();
        // this.queryTotalRiskItem();

        this.localDriverDetail = this.driverDetail;
        this.driverId = this.driverDetail['id'] || this.driverDetail['driverId'];

        this.getDriverDic();

        this.checkDriverFlag();

    }

}

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, SkeletonModule, PDetailSidebarModule, 
        DriverDetailModule, TruckDetailModule, ProgressBarModule,
        DialogModule,
        TimelineModule,
        RadioButtonModule,
        CheckboxModule,
        ButtonModule,
        CommonConfirmModule,
        ImageViewerModule,
        InputTextareaModule,
        FieldsetModule,
        CalendarModule,
        ScrollPanelModule,
        TooltipModule,
        TagModule,
        AccordionModule
    ],
    exports: [DriverExamineComponent],
    declarations: [DriverExamineComponent]
})
export class DriverExamineModule { }
